// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jmbhdrcvypdcygbwqqjr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImptYmhkcmN2eXBkY3lnYndxcWpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIyNjU2NjQsImV4cCI6MjA2Nzg0MTY2NH0.IAGgNxQ8y0G23uwVxrk333DSSENBvoV9yjEXJ-H5z2Y";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});